import { SMH } from '@/renderer/scripts/smh';
import storage from '@/renderer/scripts/utils/storage';
interface SearchState {
  // 上一个路由
  previousRoute: {
    name: string;
    query?: string;
    params?: any;
  };
  // TODO: 将增加全局搜索global
  scope: 'all' | 'current'; // 当前空间下的搜索 or 当前文件夹下的搜索
  keyword: string; // 搜索关键字
  // 搜索条件信息，用于回退搜索
  searchCondition: {
    range: string;
    types: SMH.SearchFileType[];
    times: string;
    size: string;
    member: string;
    extraData: object;
  };
  isInitConditionData: boolean;
}
const search = {
  state: {
    previousRoute: {
      name: '',
      query: '',
      params: undefined,
    },
    scope: 'all',
    keyword: '',
    searchCondition: {
      range: 'fileName',
      types: ['all'],
      times: 'all',
      size: 'all',
      member: 'all',
      extraData: {},
    },
    isInitConditionData: false,
  },
  mutations: {
    SET_SEARCH_PREVIOUSROUTE: (
      state: SearchState,
      previousRoute: {
        name: '';
      },
    ): void => {
      state.previousRoute = previousRoute;
      storage.set(storage.StoreKey.SEARCH_PREVIOUS_ROUTE, state.previousRoute);
    },
    SET_SEARCH_SCOPE: (state: SearchState, scope: 'all' | 'current'): void => {
      state.scope = scope;
      storage.set(storage.StoreKey.SEARCH_SCOPE, state.scope);
    },
    SET_SEARCH_KEYWORD: (state: SearchState, keyword: string): void => {
      state.keyword = keyword;
      storage.set(storage.StoreKey.SEARCH_KEYWORD, state.keyword);
    },
    SET_SEARCH_CONDITION: (
      state: SearchState,
      searchCondition: {
        range: string;
        types: SMH.SearchFileType[];
        times: string;
        size: string;
        member: string;
        extraData: object;
      },
    ): void => {
      state.searchCondition = searchCondition;
      storage.set(storage.StoreKey.SEARCH_CONDITION, state.searchCondition);
    },
    SET_INIT_CONDITION_DATA: (state: SearchState, isInitConditionData: boolean): void => {
      state.isInitConditionData = isInitConditionData;
    },
  },
  action: {},
  getters: {
    searchPreviousRoute(state: SearchState) {
      if (!state.previousRoute.name) {
        const previousRoute = storage.get(storage.StoreKey.SEARCH_PREVIOUS_ROUTE);
        previousRoute && (state.previousRoute = previousRoute as any);
      }
      return state.previousRoute;
    },
    searchScope(state: SearchState) {
      if (state.scope === 'all') {
        const scope = storage.get(storage.StoreKey.SEARCH_SCOPE);
        state.scope = scope as 'all' | 'current';
      }
      return state.scope;
    },
    searchKeyWord(state: SearchState) {
      if (!state.keyword) {
        const keyword = storage.get(storage.StoreKey.SEARCH_KEYWORD);
        keyword && (state.keyword = keyword as string);
      }
      return state.keyword;
    },
    searchCondition(state: SearchState) {
      const searchCondition = storage.get(storage.StoreKey.SEARCH_CONDITION);
      state.searchCondition = searchCondition as {
        range: string;
        types: SMH.SearchFileType[];
        times: string;
        size: string;
        member: string;
        extraData: object;
      };
      return state.searchCondition;
    },
    isInitConditionData: (state: SearchState) => state.isInitConditionData,
  },
};
export default search;
